import { ArrowUpRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export function FinalCta() {
  const ref = useScrollReveal<HTMLElement>();
  const { t } = useTranslation();

  return (
    <section
      ref={ref}
      className="animate-on-scroll relative py-16 sm:py-24"
      style={{ background: "oklch(100% 0 0)" }}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div
          className="relative overflow-hidden rounded-[32px] px-8 py-16 text-center sm:px-12 lg:px-16 lg:py-24"
          style={{ background: "var(--color-ther-ground)", color: "var(--color-paper)" }}
        >
          {/* Clay glow, the same clearing the hero opens over its subject */}
          <div
            aria-hidden
            className="pointer-events-none absolute -top-24 left-1/2 size-[560px] -translate-x-1/2 rounded-full opacity-50"
            style={{ background: "radial-gradient(circle, oklch(50% 0.13 40 / 0.7), transparent 60%)" }}
          />

          <div className="relative">
            <h2
              className="font-heading mx-auto max-w-3xl font-black leading-[1.05] tracking-[-0.03em]"
              style={{ fontSize: "clamp(1.9rem, 5vw, 3.5rem)" }}
            >
              {t("forTherapists.cta.title")}
            </h2>
            <p
              className="mx-auto mt-5 max-w-xl text-[15px] leading-[1.65]"
              style={{ color: "color-mix(in oklab, var(--color-paper) 78%, transparent)" }}
            >
              {t("forTherapists.cta.subtitle")}
            </p>
            <div className="mt-10 flex justify-center">
              <Link
                to="/therapist-enroll"
                className="ther-cta group inline-flex h-14 items-center gap-2 rounded-xl px-8 text-base font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
              >
                {t("forTherapists.cta.button")}
                <ArrowUpRight
                  className="size-4 transition-transform duration-300 group-hover:rotate-45"
                  weight="bold"
                  aria-hidden
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
